<template>
  <div :class="isApp ? 'main-phone' : 'main'">
    <div :class="isApp ? 'login-box-phone' : 'login-box'">
      <div class="login-box-left" v-if="isApp == false">
        <img src="../../assets/login_avator.png" class="login-box-left-avator">
      </div>
      <div :class="isApp ? 'login-box-right-phone' : 'login-box-right'">
        <div class="login-box-right-child">
          <h2>账号登录</h2>
          <el-input
            placeholder="请输入用户名"
            v-model="username"
            id="login-input">
            <i slot="prefix" class="pic_icon"><img src="../../assets/login_user.png"></i>
          </el-input>
          <br>
          <el-input
            placeholder="请输入密码"
            v-model="password" show-password
            id="login-input">
            <i slot="prefix" class="pic_icon"><img src="../../assets/login_psswd.png"></i>
          </el-input>
          <br>
          <el-button class="login-btn" type="primary" @click="showDialog" round>马上登录</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择医院"
      :visible.sync="chooseHospitalDialogVisible"
      :width="isApp ? '100%' : '40%'">
      <el-select v-model="currentHospital" @change="confirmLogin" placeholder="请选择">
        <el-option
          v-for="item in hospitalInfo"
          :key="item.hospitalId"
          :label="item.hospitalName"
          :value="item.hospitalId">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseHospitalDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmLogin">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiLogin, apiGetOwnHospital, apiSetCurrentHos } from '../../request/api'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      hospitalInfo: [],
      currentHospital: null,
      chooseHospitalDialogVisible: false,
      isApp: false
    }
  },
  mounted () {
    this.isApp = document.body.clientWidth < 900
    window.onresize = () => {
      this.isApp = document.body.clientWidth < 900
    }
  },
  methods: {
    async showDialog(){
       // 获取当前用户所在的所有医院
      let hospitalInfo = await apiGetOwnHospital({
          account: this.username
        })
        if (hospitalInfo.code === 1000) {
          this.hospitalInfo = hospitalInfo.data
          this.currentHospital = hospitalInfo.data.length === 0 ? '' : hospitalInfo.data[0].hospitalId
          if (hospitalInfo.data.length === 1) {
            this.confirmLogin()
          } else {
            this.chooseHospitalDialogVisible = true
          }
        } else {
          this.$message.error(hospitalInfo.msg)
        }
    },
    async login () {
      let resp = await apiLogin(
        {
          account: this.username,
          passwd: this.password
        }
      )
      // 请求成功
      if (resp.code === 1000) {
        this.$router.push({name: 'Home', params: {type: 0}})
        let data = resp.data
        // 设置登录状态
        sessionStorage.setItem('isLogin', 'true')
        // 存储用户账户信息
        await this.$store.dispatch('asyncUpdateUser', {account: this.username, nickname: data.nickname})
        this.$store.commit('setKeepAlive', ['Home'])
    
        return 0
      }
      // 请求失败
      this.$message.error(resp.msg)
    },
    async confirmLogin () {
      if (this.currentHospital === '') {
        this.$message.error('没有选择医院')
        return 0
      }
      let setCurHosResp = await apiSetCurrentHos({
        account: this.username,
        hospitalId: this.currentHospital
      })
      // 判断医院是否设置成功
      if (setCurHosResp.code === 1000) {
        this.login()
        // 进入首页
      } else {
        this.$message.error(setCurHosResp.msg)
      }
    }
  }
}
</script>

<style scoped>
.main {
  height: 100%;
  width: 100%;
  background-image: url("../../assets/login_bg.png");
  background-size: 100% 100%;
  overflow: hidden;
}
.main-phone {
  height: 100%;
  width: 100%;
  text-align: center;
}
.login-box {
  width: 50%;
  height: 50%;
  margin: 10% auto;
  background-image: url("../../assets/login_box.png");
  background-size: 100% 100%;
  display: flex;
}
.login-box-phone {
  margin-top: 50%;
}
.login-box-left {
  flex: 1;
  position: relative;
}
.login-box-right {
  text-align: center;
  height: 100%;
  flex: 1;
  position: relative;
}
.login-box-right-phone {
  text-align: center;
  position: relative;
}
.login-box-left-avator {
  position: absolute;
  width: 80%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.login-box-right h2 {
  color: #3381FF;
}
/deep/ #login-input.el-input__inner {
  height: 44pt;
  border-radius: 35px;
  position: relative;
}
/deep/ .el-input--prefix #login-input.el-input__inner {
  padding-left: 39.5pt;
  font-size: 8.5pt;
}
.login-box-right-child {
  height: 80%;
  position: absolute;
  width: 80%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.login-box-right .el-input[data-v-08b4fdc3] {
  width: 70%;
}
.login-box-right .el-input {
  margin-bottom: 5%;
}
.forget-passwd-tip {
  width: 38.5pt;
  font-size: 9pt;
  color: #2E7DFF;
  font-weight: bold;
  font-style: normal;
  position: absolute;
  top: 16pt;
  right: 9pt;
}
.pic_icon img {
  width: 10.5pt;
  position: absolute;
  top: 14.5pt;
  left: 19.5pt;
}
.login-btn {
  width: 60%;
  border-radius: 35px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
/deep/ .el-input #login-input.el-input__clear {
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue